var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 175,
    viewBox: "0 0 176 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.865234,
    width: 175.135,
    height: 174.822,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3184_128328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 177,
    height: 175
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.865234,
    width: 175.135,
    height: 174.822,
    fill: "url(#pattern1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3184_128328)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.865234,
    width: 175.135,
    height: 174.822,
    fill: "#D8D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3184_128328",
    transform: "scale(0.005)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3184_128328",
    transform: "scale(0.005)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3184_128328",
    width: 200,
    height: 200,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenIcon);
export default __webpack_public_path__ + "static/media/screen_icon.3c427ea2bbf2f5cb9c331dbcd8f3176c.svg";
export { ForwardRef as ReactComponent };